import { ModalMedium } from '../../../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { WCalHolidayUsedDayModelType } from '@teinor/erp/types/company/WCalParent/WCal/WCalHolidayBag/WCalHolidayUsedDay'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderDate } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { VirtualTableListingStateLess } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { DisplayStatusWithoutIcon } from '../../../../../../../../baseComponents/Displays/DisplayStatus'
import { HolidayTypesKeys, WCalHolidayBagModelType } from '@teinor/erp/types/company/WCalParent/WCal/WCalHolidayBag'
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'
import { ButtonOrLoader, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import twinFetchPost, { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { TimeControlHolidayBags } from '../../types'
import { changeErrorMessage, changeSuccessMessage } from '../../../../../../../../utils/reducers/reduxDispatch'
import useStatusRequestTypes from '../../../../../../../../utils/hooks/useStatusRequestTypes'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinCalendarStartEnd from '../../../../../../../../baseComponents/TwinCalendar/TwinCalendarStartEnd'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import './modalholidaybagdetail.sass'
import Checkbox from '../../../../../../../../forms/Checkbox'
import { CustomRenderWCalHalfDayForTable } from '../../../../../../../../specificComponents/WCal/WCalHolidayUsedDay/CustomRenderWCalHalfDay'
import useDictHolidayTypes from '../../../../../../../../utils/hooks/wCalHolidayBag/useDictHolidayTypes'

interface BasePropsHolidayBagDetail {
    holidayBagInstance: WCalHolidayBagModelType
    setOpened: ModalOpenedSetTy
    getData: () => Promise<void>
}

type ModalHolidayBagDetailProps = ModalHolidayBagDetailLogicProps & ModalEditComponentPropsWithoutSubmit & {
    getData: () => Promise<void>
    isExpiredDate: boolean
}

const ModalHolidayBagDetail: React.FC<ModalHolidayBagDetailProps> = ({ getData, holidayBag, setOpened, allRowData, isExpiredDate }) => {
    const { holidayBagInstance } = useModalHolidayBagDetailLogic({ holidayBag })
    const usedDays = holidayBagInstance?.WCalHolidayUsedDays

    return (
        <ModalMedium className={'h-full modal_medium flex flex-col overflow-auto'} opened={true} setOpened={setOpened}>
            {holidayBagInstance && !isExpiredDate ? <RequestHolidaySection holidayBagInstance={holidayBagInstance} setOpened={setOpened} defaultModalRequestValue={allRowData?.requestingHolidays} getData={getData} /> : null}
            {usedDays ? <HolidayDetailTable usedDays={usedDays} />: null}
        </ModalMedium>
    )
}

interface ModalHolidayBagDetailLogicProps {
    holidayBag: TimeControlHolidayBags
}

const useModalHolidayBagDetailLogic = ({holidayBag}: ModalHolidayBagDetailLogicProps) => {
    const [holidayBagInstance, setHolidayBagInstance] = useState<WCalHolidayBagModelType | null>(null)

    const getHolidayBag = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/employee/employeeHoliday/getEmployeeHolidayBagInstance', {
            id: holidayBag.id
        })
        if (result) {
            setHolidayBagInstance(result)
        }
    }, [setHolidayBagInstance, holidayBag.id])

    useEffect(() => {
        getHolidayBag()
    }, [getHolidayBag])
    return {holidayBagInstance}
}


type RequestHolidaySectionProps = RequestHolidaySectionLogicProps & BasePropsHolidayBagDetail & {}

const RequestHolidaySection: React.FC<RequestHolidaySectionProps> = ({ holidayBagInstance, setOpened, defaultModalRequestValue, getData }) => {
    const { tVars } = useTwinTranslation()
    const { dictHolidayTypes } = useDictHolidayTypes()

    const { requestHolidayOpened, setRequestHolidayOpened } = useRequestHolidaySectionLogic({ defaultModalRequestValue })
    return (
        <div className='mt-30'>
            <div className='flex mb-10'>
                <h1 className='text-22 text-gray-51'>
                    <TwinTrans transKey='holidays'>Vacaciones</TwinTrans>
                </h1>
                <span className='ml-auto text-16 text-green-21 cursor-pointer' onClick={() => setRequestHolidayOpened((old) => !old)}><TwinTrans transKey='requestHolidayDays'>Solicitar días de vacaciones</TwinTrans></span>
            </div>
            <span className='text-gray-51 light16'>{tVars('youHaveXDaysRemainingTypes', 'Te quedan {{leftDays}} días {{holidayType}} disponibles ', { leftDays: holidayBagInstance.leftDays, holidayType: dictHolidayTypes[holidayBagInstance.holidayType || 0 as HolidayTypesKeys].name.toLowerCase() })}</span>
            {requestHolidayOpened ? <RangeSelectorCalendars holidayBagInstance={holidayBagInstance} setRequestHolidayOpened={setRequestHolidayOpened} setOpened={setOpened} getData={getData} /> : null}
        </div>
    )
}

interface RequestHolidaySectionLogicProps {
    defaultModalRequestValue: boolean
}

const useRequestHolidaySectionLogic = ({ defaultModalRequestValue }: RequestHolidaySectionLogicProps) => {
    const [requestHolidayOpened, setRequestHolidayOpened] = useState<boolean>(defaultModalRequestValue)
    return { requestHolidayOpened, setRequestHolidayOpened }
}

interface RangeSelectorCalendarsProps extends RangeSelectorCalendarsLogicProps {
    setRequestHolidayOpened: Dispatch<SetStateAction<boolean>>
}
const RangeSelectorCalendars: React.FC<RangeSelectorCalendarsProps> = ({ holidayBagInstance, setRequestHolidayOpened, setOpened, getData }) => {
    const { dateSelected, handleOnChange, handleRequestHolidays, loading } = useRangeSelectorCalendarsLogic({ holidayBagInstance, setOpened, getData })
    const { t } = useTwinTranslation()
    const isSelectedOnlyADay = dateSelected.start.toISOString() === dateSelected.end.toISOString()
    return (
        <div className='mt-22 border-solid border-b border-gray-D6'>
            <TwinCalendarStartEnd start={dateSelected.start} end={dateSelected.end} minDate={holidayBagInstance.from ? new Date(holidayBagInstance.from) : undefined} maxDate={holidayBagInstance.to ? new Date(holidayBagInstance.to) : undefined} defaultActiveStartDate={dateSelected.start} onChange={handleOnChange} />
            <div className='flex justify-end mt-47 gap-38 mb-30'>
                {isSelectedOnlyADay ? <Checkbox label={t('holidayHalfDay', 'Medio día de vacaciones')} onChange={(value) =>handleOnChange(value, 'isHalfDay')} checked={dateSelected.isHalfDay}/> : null}
                <ButtonSecondary className='modal_edit_holidays_request_btn' onClick={() => setRequestHolidayOpened(false)}><TwinTrans transKey='cancel'>Cancelar</TwinTrans></ButtonSecondary>
                <ButtonOrLoader textButton={t('request', 'Solicitar')} buttonIsDisabled={loading} className='modal_edit_holidays_request_btn' onClick={handleRequestHolidays} />
            </div>
        </div>
    )
}

interface RangeSelectorCalendarsLogicProps extends BasePropsHolidayBagDetail {}

const useRangeSelectorCalendarsLogic = ({ holidayBagInstance, setOpened, getData }: RangeSelectorCalendarsLogicProps) => {
    const {endLoading, loading, startLoading} = useIsLoading()
    const { t } = useTwinTranslation()
    const currentDate = new Date()
    const bagDateparsed = new Date(holidayBagInstance.from)
    const [dateSelected, setDateSelected] = useState({
        start: bagDateparsed > currentDate ? bagDateparsed : currentDate,
        end: bagDateparsed > currentDate ? bagDateparsed : currentDate,
        isHalfDay: false
    })

    const messages = JSON.stringify({
        errorStartDateNotSelected: t('noStartDateSelected', 'Fecha de inicio no seleccionada'),
        'No left days': t('notEnoughHolidayDaysLeft', 'No quedan suficientes días de vacaciones'),
        'The day picked must be a working day': t('mustBeWorkingDay', 'La fecha seleccionada debe ser un día laborable'),
        'The day picked is not available': t('datePickedNotAvailable', 'La fecha seleccionada no está disponible'),
        success: t('successfullyCompleted', 'Realizado correctamente'),
    })
    
    const handleOnChange = useCallback((value: Date | boolean, type: 'start' | 'end' | 'isHalfDay') => {
        setDateSelected((old) => {
            return { ...old, isHalfDay: false, [type]: value }
        })
    }, [setDateSelected])

    const handleRequestHolidays = useCallback(async () => {
        startLoading()
        const messagesParsed = JSON.parse(messages)
        let dateParsedEnd
        if (dateSelected.start) {
            const dateParsedStart = dateSelected.start.toDateString()
            if (dateSelected.end) {
                dateParsedEnd = dateSelected.end.toDateString()
            }
            const result = await twinFetchPost('/api/app/employee/employeeHoliday/createEmployeeHolidayUsedDay', {
                WCalHolidayBagId: parseInt(String(holidayBagInstance.id)),
                EmployeeId: holidayBagInstance.EmployeeId,
                from: dateParsedStart,
                to: dateSelected.end ? dateParsedEnd : dateParsedStart,
                isHalfDay: dateSelected.isHalfDay
            })
            let response = await result.json()
            if (result.status === 200) {
                setOpened(null)
                getData()
                changeSuccessMessage(messagesParsed.success)
            } else if (result.status === 422) {
                changeErrorMessage(messagesParsed[response.errors[0].msg])
            }
        } else {
            changeErrorMessage(messagesParsed.errorStartDateNotSelected)
        }
        endLoading()
    }, [holidayBagInstance.id, dateSelected, setOpened, getData, messages, holidayBagInstance.EmployeeId, startLoading, endLoading])
    return { dateSelected, handleOnChange, handleRequestHolidays, loading }
}

interface HolidayDetailTableProps {
    usedDays: WCalHolidayUsedDayModelType[]
}

const HolidayDetailTable: React.FC<HolidayDetailTableProps> = ({ usedDays }) => {
    const {t} = useTwinTranslation()
    const columns: ColumnTableSchema<WCalHolidayUsedDayModelType> = [
        {
            id: 'from',
            dataKey: 'from',
            label: t('from', 'Desde'),
            customRender: (parameterValue) => <CustomRenderDate value={parameterValue} />,
        },
        {
            id: 'to',
            dataKey: 'to',
            label: t('to', 'Hasta'),
            customRender: (parameterValue, allRowData) => <CustomRenderWCalHalfDayForTable endDate={parameterValue} isHalfDay={allRowData.isHalfDay}/>
        },
        {
            id: 'approved',
            dataKey: 'approved',
            label: t('status', 'Estado'),
            customRender: (parameterValue) => <RenderUsedDayStatus value={parameterValue} />,
            minWidth: 150
        },
    ]
    return (
        <div className='mb-20 mt-25 flex flex-col flex-auto min-h-300'>
            <div className='justify-between items-center mb-20'>
                <h2 className='text-18 text-gray-51'>
                    <TwinTrans transKey='usedDaysRequiredDetail'>Detalle de tus vacaciones solicitadas</TwinTrans>
                </h2>
            </div>
            <div className='flex-auto h-1 overflow-auto'>
                <VirtualTableListingStateLess tableData={usedDays} rowHeight={48} headerHeight={48} name='HolidayRequestDetail' columns={columns} setSelectedColumnsAndFilters={() => { }} />
            </div>
        </div>
    )
}

interface RenderUsedDayStatusProps {
    value: string
}

const RenderUsedDayStatus: React.FC<RenderUsedDayStatusProps> = ({ value }) => {
    const status = useStatusRequestTypes()
    const parsedValue = parseInt(value)
    return <DisplayStatusWithoutIcon colorText={status[parsedValue].colorText} text={status[parsedValue].name} />
}

export default ModalHolidayBagDetail